import React from "react";

import { ApplicantUserCitizenship, ApplicantUserContactInformation, ApplicantUserIdentityDetails, ApplicantUserProfessional, CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryDocument, Entity } from "../../../../../../generated";
import { useQuery } from "@apollo/client";
import { lookupCountryQuery } from './credential-verification-archive-country-query';
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { CollapsibleApplicantProfile } from "../../../../../shared/collapsible-applicant-profile/collapsible-applicant-profile";
import { Country } from "../../../../../../types/country";

interface CollapsibleApplicantProfileArchivedContainerProps {
  caseId: string;
}

export const CollapsibleApplicantProfileArchivedContainer: React.FC<
CollapsibleApplicantProfileArchivedContainerProps
> = (props) => {
  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(
    CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryDocument,
    {
      variables: {
        archivedCredentialVerificationCaseSummaryId: props.caseId,
      },
      context: {
        headers:{
          "cache-enabled": "true"
        }
      }
    }
  );
  

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading || countryLoading}
      hasData={applicantDetailData}
      error={applicantDetailError || countryError}
      hasDataComponent={
        <CollapsibleApplicantProfile
          professional={applicantDetailData?.archivedCredentialVerificationCaseSummary?.applicant?.personalInformation?.professional as ApplicantUserProfessional}
          contactInformation={applicantDetailData?.archivedCredentialVerificationCaseSummary?.applicant?.personalInformation?.contactInformation as ApplicantUserContactInformation}
          identityDetails={applicantDetailData?.archivedCredentialVerificationCaseSummary?.applicant?.personalInformation?.identityDetails as ApplicantUserIdentityDetails}
          citizenship={applicantDetailData?.archivedCredentialVerificationCaseSummary?.applicant?.personalInformation?.citizenship as ApplicantUserCitizenship} 
          applyingTo={applicantDetailData?.archivedCredentialVerificationCaseSummary?.applicant?.personalInformation?.applyingTo as Entity[]}  
          countryData={
            countryData?.countries?.eventPayload?.countries as Country[]
          }
        />
      }
    />
  );
};
